import { useEffect, useState } from 'react'
// reason: FIXME at moment we rely too much on custom styling, we need all accessibilites from menu item but own styling
// eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
import { BottomNavigation as MuiBottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { Badge, spacing } from '@dhl-ui/components'
import { type PageBottomMenuItem } from './types'
import { getActiveItem } from './get-active-item'

type Props = {
  /**
   * Items at the bottom, make sure not to have more then 4 items since we use BottomMenu on mobile :)
   */
  items: PageBottomMenuItem[]

  /**
   * The value from your menu items which has been selected will be returned to take the correct action
   */
  onSelect: (item: PageBottomMenuItem) => void
}

export const bottomMenuHeight = spacing(7)
export const bottomMenuHeightSave = spacing(7.125)

/**
 * Mostly for mobile apps for Page and PageWithRefresh
 */
export const BottomMenu = ({ items, onSelect }: Props) => {
  const [selectedAction, setSelectedAction] = useState(() => getActiveItem(items))

  /**
   * During page load we can have a change in items, for example
   * we add menu items based on users profile while already rendering the page :)
   * For this scenario next to our initial state we check for an active element
   */
  useEffect(() => {
    setSelectedAction(getActiveItem(items))
  }, [items])

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        displayPrint: 'none',
      }}
      elevation={0}
    >
      <MuiBottomNavigation
        data-testid="page-bottom-menu"
        showLabels
        value={selectedAction}
        onChange={(_, newValue) => {
          // set value internally
          setSelectedAction(newValue)

          const value = items?.find((item) => item.key === newValue)

          // tell consumer action has been choosen
          onSelect(value!)
        }}
        sx={{
          // when altering make sure to give it room in our `BasePage` as well
          height: bottomMenuHeight,
        }}
      >
        {items?.map(
          ({ icon, label, key, badge, node }) =>
            node || (
              <BottomNavigationAction
                label={label}
                icon={
                  badge ? (
                    <Badge badgeContent={badge.count} color={badge.color}>
                      {icon}
                    </Badge>
                  ) : (
                    icon
                  )
                }
                value={key}
                key={key}
                data-testid={key}
              />
            )
        )}
      </MuiBottomNavigation>
    </Paper>
  )
}
